import * as React from 'react';
import {
  Tabs, Tab, Typography, Box, Grid, Card, CardMedia, CardContent, CircularProgress, Tooltip,
} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../reduxState/store';
import { Gallery_BASE_URL } from '../../config';
import { fetchCategoryType } from '../../reduxState/categoryType/categoryType';
import { fetchBranchs, clearListState } from '../../reduxState/branchSlice/branchGetallslice';
import merchantlogoEmpty from '../../assets/images/merchantlogoEmpty.webp'
import merchantEmpty from '../../assets/images/merchantEmpty.webp'
import ListSkeleton from '../commonToast/skeleton/listSkeleton';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box py={3}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface ConfirmationModalProps {
  page: any,
  limit: any,
  isVeg: any,
  cuisineName: any,
  submit: any
}

const ProductMerchantListTab: React.FC<ConfirmationModalProps> = ({ page, limit, isVeg, cuisineName, submit }) => {
  const [value, setValue] = React.useState(0);
  const location = useLocation();
  const navigate = useNavigate()
  const branch = useSelector((state: RootState) => state.branchList);
  const cuisineType = useSelector((state: RootState) => state.categoryTypeList);
  const dispatch = useDispatch<AppDispatch>();

  React.useEffect(() => {
    dispatch(fetchCategoryType(''))
  }, [])

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleListPage = (merchant: any) => {
    const data = {
      id: merchant,
      type: 'product'
    }
    navigate("/merchant-product/list", { state: data })
    dispatch(clearListState())
  };

  const handleMerchantList = (cuisine: any) => {
    if (cuisine === 'empty') {
      dispatch(fetchBranchs({ categoryId: location.state, status: 'ACTIVE', pageNo: page, size: limit, isVeg: isVeg ? 'Veg' : 'Both' }))
    } else {
      dispatch(fetchBranchs({ categoryId: location.state, categoryType: cuisine.id, status: 'ACTIVE', pageNo: page, size: limit, isVeg: isVeg ? 'Veg' : 'Both' }))
    }
  }

  //unique category type identify 
  const cuisine = cuisineType?.data?.map((category: any) => category);
  cuisine.unshift({ name: 'All' })

  React.useEffect(() => {
    const categoryType = cuisine?.map((name: any) => name.name)
    if (categoryType.length === cuisineName.length + 1 && submit) {
      setValue(0)
    } else if (cuisineName && cuisineName.length > 0 && submit) {
      setValue(categoryType.indexOf(cuisineName[0]))
    }
  }, [cuisineName, submit])

  return (
    <Box sx={{ width: '100%' }}>
      <Box>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          className='roboto-med list-tab'
          aria-label="scrollable auto tabs example">
          {cuisine?.map((cuisine, index) => (
            <Tab key={index} label={cuisine.name} {...a11yProps(index)} onClick={() => { handleMerchantList(cuisine) }} className='list-tab-button' />
          ))}
        </Tabs>
      </Box>
      {cuisine.map((cuisine, index) => (
        <TabPanel value={value} index={index} key={index}>
          {branch.size === 0 && branch.loading === false ?
            <Box width={'100%'} textAlign={'center'} my={5} py={5}>
              <img src={merchantEmpty} alt={branch.message} width={300} height={300} loading='lazy'/>
            </Box> :
            branch.loading === false && branch.code === 200 ?
              <Grid container spacing={2.5} minHeight='50vh'>
                {branch.data.map((branch, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Card className='merchant-list-card' sx={{ borderRadius: '18px', padding: '5px' }}>
                      <Tooltip title={branch?.branchName} followCursor>
                        <Box onClick={() => { handleListPage(branch?.id) }}>
                          {branch?.image && branch?.image.length > 0 ?
                            <CardMedia
                              component="img"
                              height="140"
                              image={`${Gallery_BASE_URL}${branch?.image[0].filePath}`}
                              alt={branch?.branchName}
                              sx={{ borderRadius: '18px', width: '100%', objectFit: 'cover' }}
                              loading='lazy'
                            /> :
                            <CardMedia
                              component="img"
                              height="140"
                              image={merchantlogoEmpty}
                              alt={branch?.branchName}
                              sx={{ borderRadius: '18px', width: '100%', objectFit: 'cover' }}
                              loading='lazy'
                            />}
                          <CardContent sx={{ p: 1 }}>
                            <Grid container justifyContent={'space-between'}>
                              <Grid item xs={9}>
                                <Typography className='merchant-list-name inter-med' sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{branch?.branchName}</Typography>
                              </Grid>
                              <Grid item xs={3} display='flex' justifyContent={'end'} alignItems={'center'}>
                                <Typography className='merchant-list-time inter-med'>32 min</Typography>
                              </Grid>
                              <Grid item xs={12} py={1}>
                                <Typography className='merchant-list-category-subcategory inter-med'>{branch?.categoryTypeDetails.map((cuisine: any) => cuisine.name).join(', ')}</Typography>
                              </Grid>
                              <Grid item xs={2.5} >
                                <Typography className='merchant-list-rating inter-med' sx={{ padding: '5px' }}>{branch?.rating} <StarIcon sx={{ fontSize: '0.85rem', ml: 0.5 }} /></Typography>
                              </Grid>
                              <Grid item xs={8} display='flex' justifyContent={'end'} alignItems={'center'}>
                                <Typography className='merchant-list-amount inter-med'>&#x20B9; {branch?.branchMinAmount} for one</Typography>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Box>
                      </Tooltip>
                    </Card>
                  </Grid>
                ))}
              </Grid> :
              <Grid container spacing={2.5}>
                <ListSkeleton listsToRender={20} />
              </Grid>
          }
        </TabPanel>
      ))}
    </Box>
  );
}


export default ProductMerchantListTab;